/* Spanish catalog mirroring locale-invoice-list-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inv.title': 'Facturas',
  'inv.titleHelp': 'Resumen de facturas, presupuestos, confirmaciones de pedido y notas de crédito del ejercicio fiscal seleccionado.',
  'inv.searchPh': 'Buscar por número de factura, cliente o importe',
  'inv.searchHelp': 'Busca por número de factura, nombre del cliente, importe de la factura, importe neto, importe pagado o importe restante.',
  'inv.downloadHelp': 'Descarga la lista de la pestaña y el filtro seleccionados.',
  'inv.addHelp': 'Crear una factura nueva.',
  'inv.add': 'Nueva factura',
  'inv.filterHelp': 'Filtra la lista por estado, tipo de documento, fecha, periodo, importe y archivo.',
  'inv.tabsHelpTitle': 'Tipos de documento',
  'inv.tabsHelp': 'Cambia entre Factura, Borrador, Presupuesto/Confirmación de pedido, Nota de crédito e Informe de ventas.',
  'inv.listHelpTitle': 'La lista de facturas',
  'inv.listHelp': 'Cada fila es un documento del backend. Pulsa una fila para ver los detalles y las acciones.',
  'inv.loading': 'Cargando facturas',
  'inv.loadingSub': 'Obteniendo datos del backend.',
  'inv.noMatch': 'Sin resultados aquí',
  'inv.noMatchSub': 'Prueba con otra pestaña o borra el filtro.',
  'inv.backToVouchers': 'Volver a los movimientos',
  'inv.type.invoice': 'Factura',
  'inv.type.quote': 'Presupuesto',
  'inv.type.orderConfirmation': 'Confirmación de pedido',
  'inv.type.creditNote': 'Nota de crédito',
  'inv.type.unknown': 'Documento',
  'inv.tab.salesReport': 'Informe de ventas',
  'inv.importHistory.tab': 'Historial importado',
  'inv.importHistory.loading': 'Cargando el historial de facturas importado …',
  'inv.importHistory.error': 'No se pudo cargar el historial de facturas importado.',
  'inv.importHistory.readOnly': 'Este es un historial de solo lectura del sistema anterior. No afecta a la contabilidad ni al IVA y no tiene acciones de factura en Plumme.',
  'inv.importHistory.documents': 'Documentos',
  'inv.importHistory.year': 'Historial importado de {year}',
  'inv.importHistory.netSales': 'Ventas netas',
  'inv.importHistory.customers': 'Clientes',
  'inv.importHistory.creditNotes': 'Notas de crédito',
  'inv.importHistory.netIncluded': 'Deducido de las ventas netas',
  'inv.importHistory.search': 'Buscar por número de factura o cliente',
  'inv.importHistory.empty': 'No hay detalles de facturas importados para este año',
  'inv.importHistory.emptySub': 'Los totales contables importados se siguen usando en los informes y recomendaciones cuando están disponibles.',
  'inv.importHistory.detailTitle': 'Detalles del archivo de importación',
  'inv.importHistory.dueDate': 'Fecha de vencimiento',
  'inv.importHistory.paidDate': 'Fecha de pago',
  'inv.importHistory.remaining': 'Pendiente',
  'inv.importHistory.lines': 'Líneas importadas',
  'inv.importHistory.noLines': 'El sistema de origen solo proporcionó los totales de factura de este documento.',
  'inv.importHistory.markSettled': 'Marcar como saldada',
  'inv.importHistory.reopenStatus': 'Reabrir estado',
  'inv.importHistory.manualSettledNote': 'Marcada como saldada en Plumme sin contabilización.',
  'inv.importHistory.settledToast': 'La factura importada se ha marcado como saldada.',
  'inv.importHistory.reopenedToast': 'La factura importada se ha reabierto.',
  'inv.importHistory.statusError': 'No se pudo actualizar la factura importada.',
  'inv.importHistory.sourceNote': 'Importado del sistema anterior: el documento está guardado en el archivo de importación.',
  'inv.importHistory.creditReference': 'Nota de crédito importada del sistema anterior: abona la factura {number}.',
  'inv.importHistory.creditedReference': 'Importado del sistema anterior · abonada por la nota de crédito {number}',
  'inv.importHistory.reanalysisTitle': 'El historial de facturas importado debe analizarse de nuevo',
  'inv.importHistory.reanalysisBody': 'El análisis guardado es anterior a la lectura de notas de crédito desde hojas de notas de crédito independientes. Los datos de origen no se modificarán.',
  'inv.importHistory.reanalysisAction': 'Ir al reanálisis',
  'inv.importHistory.rowSource': 'Importado del sistema anterior',
  'adv.sales.importedHistoryNote': 'El análisis combina las facturas de Plumme contabilizadas con el historial de ventas de solo lectura de la importación. Las notas de crédito se deducen. {coverage}',
  'adv.sales.importedTotalsCoverage': 'La importación contiene los totales de factura, pero no las líneas de producto de todos los documentos.',
  'adv.sales.importedLinesCoverage': 'La importación también contiene líneas de factura de una parte del historial.',
  'inv.tab.drafts': 'Borradores',
  'inv.filterDocType': 'Tipo de documento',
  'inv.filterArchive': 'Archivo',
  'inv.filterSeeArchived': 'Mostrar archivados',
  'inv.status.draft': 'Borrador',
  'inv.status.created': 'No enviada',
  'inv.status.sent': 'Enviada',
  'inv.status.accepted': 'Aceptado',
  'inv.status.confirmed': 'Confirmado',
  'inv.status.paid': 'Pagada',
  'inv.status.unpaid': 'Pendiente de pago',
  'inv.status.overdue': 'Vencida',
  'inv.status.credited': 'Abonada',
  'inv.kpi.invoiceCount': 'Facturas',
  'inv.kpi.invoiceCount.help': 'El número de facturas que has creado en el año seleccionado, sea cual sea su estado.',
  'inv.kpi.revenue': 'Ingresos',
  'inv.kpi.revenue.help': 'El total de todas las facturas del año sin IVA.',
  'inv.kpi.notSent': 'No enviadas',
  'inv.kpi.notSent.help': 'Facturas en borrador a la espera de ser enviadas.',
  'inv.kpi.credited': 'Abonadas',
  'inv.kpi.credited.help': 'El número de notas de crédito.',
  'inv.kpi.quotes': 'Presupuestos',
  'inv.kpi.quotes.help': 'El número de presupuestos del año.',
  'inv.kpi.accepted': 'Aceptados',
  'inv.kpi.accepted.help': 'El número de presupuestos que el cliente ha aceptado.',
  'inv.kpi.orders': 'Confirmaciones de pedido',
  'inv.kpi.orders.help': 'El número de confirmaciones de pedido del año.',
  'inv.kpi.creditNotes': 'Notas de crédito',
  'inv.kpi.creditNotes.help': 'El número de notas de crédito del año.',
  'inv.kpi.value': 'Valor',
  'inv.kpi.value.help': 'El valor total sin IVA de los documentos de esta pestaña.',
  'inv.kpi.amount': 'Importe',
  'inv.kpi.amount.help': 'El importe total sin IVA de las notas de crédito.',
  'inv.kpi.sent': 'Enviados',
  'inv.kpi.sent.help': 'El número de documentos enviados al cliente.',
  'inv.kpi.confirmed': 'Confirmadas',
  'inv.kpi.confirmed.help': 'Confirmaciones de pedido que el cliente ha confirmado.',
  'inv.kpi.drafts': 'Borradores',
  'inv.kpi.drafts.help': 'Documentos que aún no se han enviado.',
  'inv.kpi.potentialRevenue': 'Ingresos potenciales',
  'inv.kpi.potentialRevenue.help': 'El valor total de los borradores que todavía se pueden enviar.',
  'inv.kpi.customers': 'Clientes',
  'inv.kpi.customers.help': 'El número de clientes únicos en los borradores.',
  'inv.kpi.history': 'Antigüedad',
  'inv.kpi.history.help': 'Cuánto tiempo lleva esperando el borrador más antiguo.',
  'inv.kpi.sub.totalYear': 'Total este año',
  'inv.kpi.sub.exVat': 'Sin IVA',
  'inv.kpi.sub.waiting': 'Esperando tu acción',
  'inv.kpi.sub.creditNotes': 'Notas de crédito',
  'inv.kpi.sub.started': 'Documentos iniciados',
  'inv.kpi.sub.uniqueCustomers': 'Clientes únicos',
  'inv.kpi.sub.oldestDraft': 'Borrador más antiguo',
  'inv.kpi.sub.noDrafts': 'Sin borradores',
  'inv.kpi.sub.none': 'Ninguno',
  'inv.kpi.sub.days': '{n} días',
  'inv.kpi.sub.sentQuotes': 'Presupuestos enviados',
  'inv.kpi.sub.accepted': 'Aceptados',
  'inv.kpi.sub.confirmed': 'Confirmadas',
  'inv.kpi.sub.notSent': 'No enviados',
  'inv.kpi.sub.sent': 'Enviados',
  'inv.col.document': 'Documento',
  'inv.col.invoice': 'Factura',
  'inv.col.date': 'Fecha',
  'inv.col.net': 'Neto',
  'inv.col.amount': 'Importe',
  'inv.col.status': 'Estado',
  'inv.col.number': 'N.º',
  'inv.col.customer': 'Cliente',
  'inv.netInline': 'Neto {amount}',
  'inv.draftPlaceholder': 'BORRADOR',
  'inv.detail.dueTitle': 'Fecha de vencimiento',
  'inv.detail.dueHelp': 'La fecha hasta la que el documento es válido o en la que debe pagarse.',
  'inv.detail.statusHelp': 'Los pagos proceden de los registros PaymentEntry contabilizados. Los presupuestos y las confirmaciones de pedido muestran el estado de finalización.',
});
